// Loading the self-hosted Scalar bundle.
//
// Kept separate from routes/Reference.tsx so the bundle loads exactly once per
// session no matter how often a mount remounts.
//
// The URL is same-origin and self-hosted (`/scalar/standalone.js`, served by the
// service from `@scalar/api-reference`). Same-origin is a security requirement,
// not a preference: the reference page holds an OAuth access token and a sandbox
// API key, so a third-party script origin would own both.

export interface ScalarGlobal {
  createApiReference: (
    element: Element,
    configuration: Record<string, unknown>
  ) => { destroy?: () => void } | void
}

export const loadScalar = (cdnUrl: string): Promise<ScalarGlobal> => {
  const existing = (window as unknown as { Scalar?: ScalarGlobal }).Scalar
  if (existing) return Promise.resolve(existing)

  return new Promise((resolve, reject) => {
    // Reuse an in-flight tag if a route remounts before the first load lands.
    const selector = `script[data-scalar-cdn="${cdnUrl}"]`
    const attach = (script: HTMLScriptElement) => {
      script.addEventListener('load', () => {
        const scalar = (window as unknown as { Scalar?: ScalarGlobal }).Scalar
        if (scalar) resolve(scalar)
        else reject(new Error('Scalar bundle loaded without a global'))
      })
      script.addEventListener('error', () =>
        reject(new Error('Scalar bundle failed to load'))
      )
    }

    const found = document.querySelector<HTMLScriptElement>(selector)
    if (found) return attach(found)

    const script = document.createElement('script')
    script.src = cdnUrl
    script.async = true
    script.dataset.scalarCdn = cdnUrl
    attach(script)
    document.head.append(script)
  })
}
